import axios from 'axios'
import {FormikValues} from 'formik'
    

const API_URL = process.env.REACT_APP_API_URL

const headers = {
    'Content-Type': 'application/json',
    'Accept' : 'application/json'
}

const listfield_file : Array<any> = ['field_files', 'field_photo']
const listfield_paragraph : Array<any> = [
	/*
	{
		'field_name': 'field_external_authors', 
		'type': 'author_external'
	},
	
	*/
	{
		'field_name': 'field_cv', 
		'type': 'cv',
		'sub_field_para':[
			{
				'field_name': 'field_cv_line', 
				'type': 'cv_line'
			}
		]
	}

]
const listfield_autocomplete_entity : Array<any> = ['field_authors', 'field_campus', 'field_review', 'field_faculty', 'field_external_authors', 'field_domain', 'field_goal_of_sustainable_develo'] 

function SubmitForm(submittedValues: FormikValues, type: string, user:number, form_name: string , nid?: string, setSubmitId?: any){

    // REST SERVICES URL
    const FORM_URL = (id?: any) =>{return id ? `${API_URL}/node/${id}?_format=json`: `${API_URL}/node?_format=json`}
    const FORM_PARA_URL = (entity_id?: any) =>{return entity_id ?`${API_URL}/entity/paragraph/${entity_id}?_format=json` : `${API_URL}/entity/paragraph?_format=json`}

    // INIT REBUILD VALUES
    var ValuesRebuilt :any= {'type': type}
    ///var rebuildPara : any = {}

    // REGULAR FIELD BEING REBUILD FOR LATER PUSH TO NODE IF NOT EMPTY
    Object.entries(submittedValues).forEach((item: any)=>{
        if(item[1] !== ""){
            var index = item[0]
            ValuesRebuilt[index] = [item[1]]
        }
    })

    // INIT THE BROKEN PROMISES
    let listPromises : Array<any> = []


    // PREPARING FILES UPLOAD
    listfield_file.forEach((field_name: string)=>{
	    
	    let indexFile: number = 0
	    
        //SET EXISITNGS FILES
        if(typeof window.FormSettings[form_name][field_name] != "undefined" && typeof window.FormSettings[form_name][field_name].default_value_data != "undefined"){
	        
	    	ValuesRebuilt[field_name] = []
	    
	        Object.values( window.FormSettings[form_name][field_name].default_value_data).forEach((file: any, i:number)=>{
		        if(typeof file != "undefined"){
					ValuesRebuilt[field_name].push({'target_id': file.id})
					indexFile++
				}
	        })
        }
        
        if(typeof submittedValues[field_name] !== 'undefined' && submittedValues[field_name] !== ''){
	        
	        
	        //SEND NEW FILES
            Object.values(submittedValues[field_name]).forEach((file: any, i:number)=>{

                const uri = API_URL+'/file/upload/node/'+ type+'/'+ field_name+'?_format=json'
                const headers_alt = {
                    "Content-Type": "application/octet-stream",
                    "Accept": "application/hal+json",
                    "Content-Disposition": `file; filename="${file.name}"`,
                }
                
                let indexFileLocal = indexFile
                indexFile++

                let result = new Promise((resolve) => {
                    let fileReader = new FileReader();
                    fileReader.onload = (e) => resolve(fileReader.result);
                    fileReader.readAsArrayBuffer(file);
                }).then((rep: any) => {
                    return axios.post(uri, rep, {headers: headers_alt}) // RETURN
                }).then(res=>{
                    ValuesRebuilt[field_name][indexFileLocal] = {'target_id': res.data.fid[0]['value']}
                })

                listPromises.push(result)
            })
        }
    })
    


    let listPromisesParas : Array<any> = []
	const processPara = ((fields: any, parent_name?: string, parent_delta?: any)=> {
		let resultPromises: any[] = []
		listPromisesParas = []
		
	    Object.values(fields).forEach((field: any)=> {
		     var values : any[] = submittedValues[field.field_name]
	        if(typeof parent_name != 'undefined'){
		        values = submittedValues[parent_name][parent_delta][field.field_name]
	        }
	        
	        if (typeof values !== 'undefined') {
		       
		        //console.log("values", values)
	            const brokenPromises = Object.values(values).reduce((chain: any, item: any, d: number) => {
		            
		            //ON NE TRAITE PAS LES PARA SUPPRIME
			         //   console.log("Object.values(item).length", Object.values(item).length, Object.values(item).length === 0)
		            if(Object.values(item).length === 0){
			            if(typeof parent_name != 'undefined'){
						//	ValuesRebuilt[parent_name][parent_delta][field.field_name][d] = undefined
						}
						if(ValuesRebuilt[field.field_name]){
			            	ValuesRebuilt[field.field_name][d] = undefined
			            }
			          //  console.log("EMPTY", item, field)
			            return chain
	                    .then(() => {return true});
		            }else{
		            
		                //IF SUBPARA
		                var sub_paras_promise: any[] = []
		                if(typeof field.sub_field_para !== 'undefined'){
			                sub_paras_promise = processPara(field.sub_field_para, field.field_name, d)
		                }
		                                
			           // console.log("sub_paras_promise", field.type, listPromisesParas, sub_paras_promise)
			
						return Promise.all(sub_paras_promise).then(function (v) {
							
							
			            	//console.log("IN PROMISE", field.type)
			
			                //let entity_id : any = null
			                // Prepare general infos
			                let rebuildPara : any = {'type': field.type}//TODO DYNAMISER
			                // Looping through para fields
			                Object.entries(item).forEach((field: any) =>{
			                    if(field[1] !== ""){
			                        var index = field[0]
			                        if(typeof field[1] == 'object'){
				                        rebuildPara[index] = Object.values(field[1])
			                        }else{
			                        	rebuildPara[index] = [field[1]]
			                        }
			                    }
			                })
		                
							console.log("rebuildPara", field.type, rebuildPara)
							console.log("item", item)
							if(rebuildPara["id"]){
								//EDITION
								return chain
				                    .then(() => axios.patch(FORM_PARA_URL(rebuildPara["id"]), rebuildPara, {headers: headers}))
				                    .then((rep: any) => {
					                    var res : Object = {'target_id': rep.data.id[0]['value'], 'target_revision_id': rep.data.revision_id[0]['value']}
					                    if(typeof parent_name != 'undefined'){
						                    /*
						                    if(typeof ValuesRebuilt[parent_name][parent_delta][field.field_name] == 'undefined'){
									        	ValuesRebuilt[parent_name][parent_delta][field.field_name] = []
									        }
									        ValuesRebuilt[parent_name][parent_delta][field.field_name][d] = res
									        */
									        submittedValues[parent_name][parent_delta][field.field_name][d] = res
								        }else{
									        ValuesRebuilt[field.field_name][d] = res;
								        }
				                        
										console.log('STRINGIFIED PARA EDIT', field.type, ValuesRebuilt)
				                        return true; // pour être sûr de passer à la suite ? pas sûr que ce soit nécessaire, ou peut-être qu'il faut renvoyer Promise.resolve() plutôt, j'sais ap mdr
				                    });
							}else{
								//AJOUT
				                return chain
				                    .then(() => axios.post(FORM_PARA_URL(), rebuildPara, {headers: headers}))
				                    .then((rep: any) => {
				                        var res : Object = {'target_id': rep.data.id[0]['value'], 'target_revision_id': rep.data.revision_id[0]['value']}
					                    if(typeof parent_name != 'undefined'){
						                    /*
									        if(typeof ValuesRebuilt[parent_name][parent_delta][field.field_name] == 'undefined'){
									        	ValuesRebuilt[parent_name][parent_delta][field.field_name] = []
									        }
									        ValuesRebuilt[parent_name][parent_delta][field.field_name][d] = res
									        */
									        submittedValues[parent_name][parent_delta][field.field_name][d] = res
								        }else{
									        ValuesRebuilt[field.field_name][d] = res
								        }
								        
										console.log('STRINGIFIED PARA', field.type, ValuesRebuilt)
				                        return true; // pour être sûr de passer à la suite ? pas sûr que ce soit nécessaire, ou peut-être qu'il faut renvoyer Promise.resolve() plutôt, j'sais ap mdr
				                    });
			                }
			            })
		            }
	            }, Promise.resolve());
				
				
				console.log("brokenPromises", brokenPromises)
					
				if(typeof parent_name == 'undefined'){
	            	listPromises.push(brokenPromises)
	            	
					console.log("listPromises", listPromises)
	            }else{
	            	resultPromises.push(brokenPromises)
	            	listPromisesParas.push(brokenPromises)
	            }
	            
	        } 
	    })
	    
	    if(resultPromises.length === 0){
		    //EMPTY PROMISE
		   // var empty_promise: any = new Promise().then(() => {return true})
		   // resultPromises.push(empty_promise)
	    }
	    
	    return resultPromises
    })
    
    //PREPARE PARA
    processPara(listfield_paragraph) 
    
    // PREPARING DATA AUTOCOMPLETE ENTITY (STRING => ARRAY)
    listfield_autocomplete_entity.forEach((field_name: string)=>{
        if(typeof submittedValues[field_name] !== 'undefined' && submittedValues[field_name] !== ''){
            ValuesRebuilt[field_name] = submittedValues[field_name].split(", ")
        }
    })


    // WAITING FOR THE BROKEN PROMISES
    console.log("listPromises", listPromises)
    Promise.all(listPromises).then(function (values) {

        console.log('STRINGIFIED VALUES REBUILT', JSON.stringify(ValuesRebuilt))
        console.log('VALUES REBUILT', ValuesRebuilt)
        // Is update or create ?
        if(nid){
        axios.patch(FORM_URL(nid), ValuesRebuilt, {headers: headers})
        	.then((response) => {
	        	console.log("NODE EDIT REP", response.data, response.data.nid[0].value);
	        	//setSubmitId(response.data.nid[0].value)
	        }).catch((error) => {
		        console.log(error)
		    })
		}else{
        	axios.post(FORM_URL(), ValuesRebuilt, {headers: headers})
        		.then((response) => {
	        		console.log('NODE CREATE REP',response)
					//setSubmitId(response.data.nid[0].value)
	        	}).catch((error) => {console.log(error)})
        }
    })
}

export {SubmitForm};